// Form1.js
import React, { useState, useRef } from 'react';
import ChatBox from '../../custom_elements/ChatBox';
import {CustomInput, validationRules} from '../../custom_elements/CustomInput';
import CustomSelect from '../../custom_elements/CustomSelect';

export default function Form1({ nextForm, passGetFormData, passValidateAllFormFields, retrievedFormData = {}, sendChat}) {
    const formRefs = useRef([]);  // Reference array to store refs of CustomInput fields

    const getFormData = () => {
        console.log("INSIDE GETFORMDATA on Form1");
        const form = document.getElementById('form1');
        const formData = new FormData(form);
        const data = {};
        for (let [key, value] of formData.entries()) {
            data[key] = value;
        }
        return data;
    };

    React.useEffect(() => {
        console.log("INSIDE useEffect on Form1");

        passGetFormData(() => getFormData);
    }, [passGetFormData]);

    const validateAllFormFields = () => {
      console.log("validateAllFormFields in Form1");
      let isValid = true;

      // Ensure refs are properly populated
      if (formRefs.current.length === 0) {
        console.error("No form refs found!");
        return false;
      }

      // Loop through all form inputs and call validateField on each one
      formRefs.current.forEach(inputRef => {
        if(inputRef != null) {
          console.log("checking ref: ", inputRef);
          // Check if inputRef is defined and properly set
          if (inputRef?.validateField()) {
            console.log("Field is valid:", inputRef?.validateField());
          } else {
            console.warn("Ref is not initialized or validateField failed:", inputRef);
            isValid = false; // Optional: Fail validation if ref is not set or invalid
          }
        }
      });

      return isValid;
    };

    React.useEffect(() => {
        console.log("INSIDE useEffect passValidateAllFormFields on Form1");

        passValidateAllFormFields(() => validateAllFormFields);
    }, [passValidateAllFormFields]);

    return (
        <div className="formFieldBox">
            <a className="toggleButton" style={{cursor: "default"}}>
                WOHNTRAUM
            </a>
            <form id="form1">
            <div className="formFieldContent">
                <div className="fieldDiv">
                    <CustomSelect ref={el => formRefs.current[6] = el} formData={retrievedFormData} label="Vorhaben*" name="zweck" rules={[{ruleKey: "required"}]}>
                        <option value="1">Hauskauf</option>
                        <option value="2">Hausbau</option>
                        <option value="3">Grundkauf</option>
                        <option value="4">Grundkauf/Hausbau</option>
                        <option value="5">Reihenhauskauf</option>
                        <option value="13">Eigentumswohnungskauf</option>
                        <option value="9">Umbau/Ausbau Wohnung</option>
                        <option value="10">Umbau/Ausbau Haus</option>
                        <option value="11">Umschuldung Wohnung</option>
                        <option value="12">Umschuldung Haus</option>
                    </CustomSelect>

                    {(retrievedFormData && 'zweck' in retrievedFormData && (retrievedFormData.zweck == "11" || retrievedFormData.zweck == "12")) && (
                        <CustomInput ref={el => formRefs.current[7] = el} formData={retrievedFormData} sendChat={sendChat} label="Verkehrswert der Immobilie*" name="verkehrswert" rules={[{ruleKey: "number"}, {ruleKey: "required"}]} />
                    )}
                    {(retrievedFormData == null || !('zweck' in retrievedFormData) || (retrievedFormData.zweck != "11" && retrievedFormData.zweck != "12")) && (
                        <CustomInput ref={el => formRefs.current[8] = el} formData={retrievedFormData} sendChat={sendChat} label="Kaufpreis*" name="k_erwerb" rules={[{ruleKey: "number"}, {ruleKey: "required"}]}>
                            Bitte geben Sie den Kaufpreis Ihrer Immobilie ein.
                        </CustomInput>
                    )}

                    {/*
                    <CustomSelect formData={retrievedFormData} label="Art der Sicherstellung" name="sicherheit" rules={[{ruleKey: "required"}]}>
                        <option value="3">Abtretung Genossenschaftsanteil</option>
                        <option value="1" >Grundbuchseintragung</option>
                        <option value="2">Grundbuch von Ersatzliegenschaft</option>
                        <option value="9">Kleingartenzession</option>
                        <option value="6">Rangordnungseintragung</option>
                        <option value="5">Keine davon</option>
                    </CustomSelect>*/}
                </div>

                {(retrievedFormData == null || !('zweck' in retrievedFormData) || (retrievedFormData.zweck !== "11" && retrievedFormData.zweck !== "12")) && (

                    <>
                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[0] = el} formData={retrievedFormData} sendChat={sendChat} name="em" label="Eigenmittel*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[1] = el} formData={retrievedFormData} sendChat={sendChat} name="em_reserve" label="Eigenmittelreserve" rules={[{ ruleKey: "number" }]} />
                    </div>

                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[2] = el} formData={retrievedFormData} sendChat={sendChat} label="Maklerkosten" name="k_makler" rules={[{ruleKey: "number"}]} />
                        <CustomInput ref={el => formRefs.current[3] = el} formData={retrievedFormData} sendChat={sendChat} label="Neben- und Aufschließungskosten" name="k_ng" rules={[{ruleKey: "number"}]}/>
                    </div>

                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[4] = el} formData={retrievedFormData} sendChat={sendChat} label="Bau- & Sanierungskosten" name="k_baukosten" rules={[{ruleKey: "number"}]} />
                        <CustomInput ref={el => formRefs.current[5] = el} formData={retrievedFormData} sendChat={sendChat} label="Anwaltskosten" name="k_anwalt" rules={[{ruleKey: "number"}]} />
                    </div>

                </>

                )}

            </div>
            </form>
        </div>
    );
}
